function dataURLtoBlob (dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = window.atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

function downloadFile (url, name) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', name)
  a.setAttribute('target', '_blank')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export default function downloadFileByBase64 (base64, name) {
  var myBlob = dataURLtoBlob(base64)
  var myUrl = URL.createObjectURL(myBlob)
  downloadFile(myUrl, name)
}

export function downloadServeFile (resp, fileDefaultName) {
  const disposition = resp.headers['content-disposition']
  const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i
  const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i
  let fileName = fileDefaultName || new Date().getTime()
  if (utf8FilenameRegex.test(disposition || '')) {
    var filenameExc = utf8FilenameRegex.exec(disposition || '')
    if (filenameExc && filenameExc[1]) {
      fileName = decodeURIComponent(filenameExc[1])
    }
  }
  if (asciiFilenameRegex.test(disposition || '')) {
    var asciiFilenameExc = asciiFilenameRegex.exec(disposition || '')
    if (asciiFilenameExc && asciiFilenameExc[1]) {
      fileName = decodeURIComponent(asciiFilenameExc[1])
    }
  }
  downloadFile(URL.createObjectURL(new Blob([resp.data])), fileName)
}
